// Espelha exatamente a sanitizacao aplicada no backend (email_service.py _email_safe_html)
// para que a pre-visualizacao no compositor mostre o email tal como sera realmente enviado.

export function emailSafeHtml(html) {
  if (!html) return html;
  let out = html;

  // 1. Corrigir <li> que contem <p>: substituir <p>conteudo</p> por conteudo + <br>
  out = out.replace(/<li>[\s\S]*?<\/li>/g, (liTag) => {
    const inner = liTag.slice(4, -5);
    if (!inner.includes("<p>")) return liTag;
    let fixed = inner.replace(/<p>([\s\S]*?)<\/p>/g, "$1<br>");
    while (fixed.endsWith("<br>")) fixed = fixed.slice(0, -4);
    fixed = fixed.replace(/\s+$/, "");
    return `<li>${fixed}</li>`;
  });

  // 2. Estilos inline em <ul>/<ol>/<li> (garante bullets visiveis em clientes de email)
  out = out.replace(/<ul(?![^>]*style=)/g, '<ul style="margin:8px 0;padding-left:24px;list-style-type:disc;"');
  out = out.replace(/<ol(?![^>]*style=)/g, '<ol style="margin:8px 0;padding-left:24px;list-style-type:decimal;"');
  out = out.replace(/<li(?![^>]*style=)/g, '<li style="margin:2px 0;"');

  // 3. Headings com estilos inline
  out = out.replace(/<h1(?![^>]*style=)/g, '<h1 style="font-size:24px;font-weight:bold;margin:12px 0 6px 0;"');
  out = out.replace(/<h2(?![^>]*style=)/g, '<h2 style="font-size:20px;font-weight:bold;margin:10px 0 5px 0;"');
  out = out.replace(/<h3(?![^>]*style=)/g, '<h3 style="font-size:16px;font-weight:bold;margin:8px 0 4px 0;"');

  // 4. Paragrafos vazios consecutivos colapsados
  out = out.replace(/(<p>\s*(<br\s*\/?>)?\s*<\/p>\s*){2,}/g, "<p></p>");

  return out;
}

// Espelha append_signature() do backend.
export function appendSignaturePreview(html, assinatura) {
  if (!assinatura) return html;
  return `${html}<br><br>-- <br>${assinatura}`;
}
